
import { ResearchLibraryItem } from '@/hooks/research-generator';

// Map filter keys to readable labels and colors
// This includes both namespaced keys (for backward compatibility) and non-namespaced keys (for new format)
const filterMapping: Record<string, { label: string; colorVariant: string }> = {
  // Technology & Innovation filters
  'technology_and_innovation_tech_domain': { label: 'Tech Domain', colorVariant: 'amber' },
  'technology_and_innovation_research_focus': { label: 'Research Focus', colorVariant: 'amber' },
  'tech_domain': { label: 'Tech Domain', colorVariant: 'amber' },
  'research_focus': { label: 'Research Focus', colorVariant: 'amber' },
  
  // Personal Development filters
  'personal_development_development_area': { label: 'Development Area', colorVariant: 'green' },
  'personal_development_outcome_focus': { label: 'Outcome Focus', colorVariant: 'green' },
  'development_area': { label: 'Development Area', colorVariant: 'green' },
  'outcome_focus': { label: 'Outcome Focus', colorVariant: 'green' },
  
  // Business & Professional filters
  'business_and_professional_industry_focus': { label: 'Industry Focus', colorVariant: 'blue' },
  'business_and_professional_analysis_type': { label: 'Analysis Type', colorVariant: 'blue' },
  'industry_focus': { label: 'Industry Focus', colorVariant: 'blue' },
  'analysis_type': { label: 'Analysis Type', colorVariant: 'blue' },
  
  // Content & Creative filters
  'content_and_creative_content_type': { label: 'Content Type', colorVariant: 'purple' },
  'content_and_creative_audience_focus': { label: 'Audience Focus', colorVariant: 'purple' },
  'content_type': { label: 'Content Type', colorVariant: 'purple' },
  'audience_focus': { label: 'Audience Focus', colorVariant: 'purple' },
  
  // Academic & Learning filters
  'academic_and_learning_subject_area': { label: 'Subject Area', colorVariant: 'indigo' },
  'academic_and_learning_research_method': { label: 'Research Method', colorVariant: 'indigo' },
  'subject_area': { label: 'Subject Area', colorVariant: 'indigo' },
  'research_method': { label: 'Research Method', colorVariant: 'indigo' },
  
  // Current Events & News filters
  'current_events_and_news_topic_area': { label: 'Topic Area', colorVariant: 'red' },
  'current_events_and_news_coverage_type': { label: 'Coverage Type', colorVariant: 'red' },
  'topic_area': { label: 'Topic Area', colorVariant: 'red' },
  'coverage_type': { label: 'Coverage Type', colorVariant: 'red' }
};

export interface FilterPill {
  label: string;
  value: string;
  colorVariant: string;
}

// Function to get filter display data
export const getFilterDisplayData = (research: ResearchLibraryItem): FilterPill[] => {
  const filters = research.research_parameters?.type_specific_filters || {};
  const filterPills: FilterPill[] = [];

  // Extract filter values and create pills
  Object.entries(filters).forEach(([key, value]) => {
    if (value && typeof value === 'string' && value.trim() !== '') {
      const mapping = filterMapping[key];
      if (mapping) {
        // Capitalize and format the value
        const formattedValue = value
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        
        filterPills.push({
          label: mapping.label,
          value: formattedValue,
          colorVariant: mapping.colorVariant
        });
      }
    }
  });

  return filterPills;
};
